import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import { ArticleImage } from '@web/utils/src';
import { env } from '@/env';
import { Article } from '@/types';

export enum ActionType {
  Default = 'default',
  Increase = 'increase',
  Decrease = 'decrease',
  Removed = 'removed',
}

interface AddToCartToastProps {
  article: Article;
  onClick: () => void;
  type?: ActionType;
}

const renderSwitch = (type: ActionType, t: TFunction) => {
  switch (type) {
    case ActionType.Default:
      return t('global.added_to_cart');
    case ActionType.Increase:
      return t('global.quantity_increased');
    case ActionType.Decrease:
      return t('global.quantity_decreased');
    case ActionType.Removed:
      return t('global.removed_from_cart');
    default:
      return t('global.added_to_cart');
  }
};

const AddToCartToast = (props: AddToCartToastProps) => {
  const { article, onClick, type = ActionType.Default } = props;
  const { t } = useTranslation();

  return (
    <div className="text-body1 flex max-w-[320px]">
      <ArticleImage
        article={article}
        className="rounded-base mr-2-0 w-4-0 h-4-0"
        env={env}
      />
      <div>
        <p className="text-body1 text-primary-green font-bd" id="toast-text">
          {renderSwitch(type, t)}
        </p>
        <p className="underline text cursor-pointer" onClick={onClick}>
          {t('global.view_cart')}
        </p>
      </div>
    </div>
  );
};

export default AddToCartToast;
